import { Column, Entity, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IRefMission } from './interface/IRefMission';
import { IRefTheme } from './interface/IRefTheme';

@Entity('ref_theme')
export class RefTheme extends BaseEntity implements IRefTheme {
    apiMapping = {
        id: 'id',
        name: 'name',
        order: 'ordre',
        isDeleted: 'isDeleted',
        refChapterRubricId: {
            fieldName: 'refChapterRubric',
            type: 'RefChapterRubric',
        },
        refMissionId: {
            fieldName: 'refMission',
            type: 'RefMission',
        },
    };

    @PrimaryGeneratedColumn()
    id: number;

    // @ManyToOne(type => RefChapterRubric)
    // refChapterRubric: RefChapterRubric;

    @Column()
    name: string;

    @Column()
    ordre: number;

    @Column()
    isDeleted: boolean;

    @ManyToOne('RefMission')
    refMission: IRefMission;
}
